/**
 * 사용자 데이터 저장
 * AS-IS : webUtil.setUserData()
 */
export interface bridgeCombo {
    /** 부점코드
     * @type {string}
     */
    brcd?: string

    /** 직원번호
     * @type {string}
     */
    emn?: string

    /** 조회목적코드
     * @type {string}
     */
    cbinqObjtCd?: string

    /** 전행고객번호
     * @type {string}
     */
    csn?: string

    /** 상품구분코드
     * @type {string}
     */
    gubun?: string

    /** 제휴사코드
     * @type {string}
     */
    acd?: string

    /** 비대면상품구분코드
     * @type {string}
     */
    grpcd?: string

    /** 제휴처 코드
     * @type {string}
     */
    alplDcd?: string

    /** 상품코드
     * @type {string}
     */
    apcd?: string

    /** NSTATION_SUBPARAM ?
     * @type {string}
     */
    nstationSubparam?: string
}

export const initialState: bridgeCombo = {
    brcd: '',
    emn: '',
    cbinqObjtCd: '',
    csn: '',
    gubun: '',
    acd: '',
    grpcd: '',
    alplDcd: '',
    apcd: '',
    nstationSubparam: '',
}
